import {combineReducers} from "@reduxjs/toolkit"
import assign from "./assign-slice";

const banking = combineReducers({
    assign
})
export default banking
